// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.navbar-brand[data-v-d737cb3c] {\n    display: inline-block !important;\n}\n.navbar-fixed-top .login-indicator[data-v-d737cb3c] {\n    display: none;\n}\n.login-indicator[data-v-d737cb3c] {\n    color: white;\n    padding-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
